import { Component } from "@angular/core";

@Component({
  templateUrl: "./refreshing.component.html",
})
export class RefreshingComponent {}
